{
    "MaxPartitions": "Es werden nur die ersten {} Partitionen auf Geräte überprüft. Bitte aktivieren Sie „Telefonieweite Berichterstattung“ in den Telsys-Einstellungen, um alle Partitionen zu überprüfen.",
    "NAME": "ErrorLanguage",
    "Error_Title": "Entschuldigung",
    "Error_SubTitle": "Wir können die gesuchte Seite nicht finden.",
    "Error_Message": "Die Seite oder Ressource wurde möglicherweise verschoben, aktualisiert oder gelöscht. \n \n Oder Sie haben die Webadresse falsch eingegeben. Bitte überprüfen Sie die Adresse und die Rechtschreibung.",
    "Error_PageTitle": "Leider können wir die gesuchte Seite nicht finden.",
    "Validations_MustBeUnique": "Der Wert muss eindeutig sein"
}